module.exports = __webpack_public_path__ + "static/media/curr_hospital.d04daba4.png";